export default "__VITE_ASSET__CxYwvSXd__"